import { useEffect } from 'react';

const ChatWidget = () => {
    useEffect(() => {
        // Configurações do chat
        window.chatwootSettings = {
            "position": "left",
            "type": "expanded_bubble",
            "launcherTitle": "Quero Agentes IA"
        };

        // Função para carregar o script do chat
        const loadChatScript = () => {
            const BASE_URL = "https://chat.synapz.tech";
            const script = document.createElement("script");
            script.src = BASE_URL + "/packs/js/sdk.js";
            script.defer = true;
            script.async = true;
            
            script.onload = function() {
                window.chatwootSDK.run({
                    websiteToken: 'jA9ha4wFq7EX1sskGhuYud4q',
                    baseUrl: BASE_URL
                });
            };
            
            document.head.appendChild(script);
        };

        // Carregar o script quando o componente for montado
        loadChatScript();

        // Função de limpeza para remover o script quando o componente for desmontado
        return () => {
            const scripts = document.querySelectorAll('script[src*="chat.synapz.tech"]');
            scripts.forEach(script => script.remove());
            
            // Remover qualquer instância do chat que possa ter sido criada
            if (window.chatwootSDK && typeof window.chatwootSDK.reset === 'function') {
                window.chatwootSDK.reset();
            }
            
            // Limpar as configurações
            delete window.chatwootSettings;
        };
    }, []);

    // Este componente não renderiza nada visível, apenas carrega o script
    return null;
};

export default ChatWidget;